

$(document).ready(function() {

    $('.nav-item-level-1 .more').on('click', function(event) {


        if (window.matchMedia('(max-width: 1019px)').matches) {

            event.preventDefault();
            event.stopPropagation();
            // $(this).toggleClass("submenu-opened");

            var elem = $(this).parent().find('> ul');

            $(this).parent().parent().find('> li > ul').each(function() {
                $(this).not(elem).slideUp('fast');
                $(this).parent().not(elem.parent()).removeClass('open');
            });

            $(this).parent().toggleClass('open');
            elem.slideToggle('fast');

        } else {

        }

    });


    $(document).on('click', '.hamburger .fa.fa-chevron-right', function() {

        var wheretogo = $(this).find('+ a').attr('href');
        // console.log('gehe direkt dorthin, gehe nicht über los');
        window.location.href = wheretogo;

    });

    $('.navbar-toggler').click(function() {
        $('body').toggleClass('nav')
    });

});